import './UserInfo.scss'
import { Link, useNavigate } from 'react-router-dom';
import UserImage from '../user-button/UserImage';
import Box, { Item } from 'devextreme-react/box';
import { useGetCurrentUserInformation } from '../../api/current-user';

export default function UserButton() {

	const currentUser = useGetCurrentUserInformation();
	const navigate = useNavigate();

	return (<>
		<div className='user-box'>
			<Box>
				<Item baseSize={50}>
					<UserImage userData={currentUser.data} imageSize={50} />
				</Item>
				<Item ratio={1}>
					<div className='user-account'>
						<div className='user-name'>{currentUser.data?.firstName + ' ' + currentUser.data?.lastName}</div>
						<div>{currentUser.data?.emailAddress}</div>
					</div>
				</Item>
			</Box>
			<div className='user-menu'>
				<a onClick={(e) => {
					navigate('/profile');
				}}>View Account</a>
				<Link to={'/logout'}>Logout</Link>
			</div>
		</div>
	</>)
}